module.exports = __webpack_public_path__ + "static/athelas-one-ea344d26d01811480f119f7307b2a1df.png";